import {
  red,
  orange,
  indigo,
  green,
  blueGrey,
  deepPurple,
  brown,
  lime,
} from '@material-ui/core/colors';
import { ru } from 'locale';

export const lang = 'ru';

export const statusesColor = {
  draft: blueGrey[500],
  scoring: indigo[500],
  contract: orange[500],
  scan: lime[500],
  limit: orange[500],
  done: green[500],
  archived: deepPurple[500],
  upd_down: red[500],
  rescore: brown[500],
};

const getVar = name => process.env[`REACT_APP_${name}`];

export const API_URL = getVar('API_URL');
export const AUTH_URL = getVar('AUTH_URL');
export const APP_NAME = getVar('APP_NAME');
export const MOCK_ACCESS_TOKEN = getVar('MOCK_ACCESS_TOKEN');
export const ACCESS_TOKEN = 'token';
export const SENTRY_DSN = getVar('SENTRY_DSN');
export const isProduction = process.env.NODE_ENV === 'production';

export const networkErrorMessages = {
  serverDown: ru.serverDown,
};

export const months = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
];

export const monthsMap = {
  Jan: 'Янв',
  Feb: 'Фев',
  Mar: 'Мар',
  Apr: 'Апр',
  May: 'Май',
  Jun: 'Июн',
  Jul: 'Июл',
  Aug: 'Авг',
  Sep: 'Сен',
  Oct: 'Окт',
  Nov: 'Ноя',
  Dec: 'Дек',
};

export const CURRENCY_MAP = {
  EUR: '\u20ac',
  RUR: '\u20bd',
  USD: '\u0024',
};

export const ROW_HEIGHT = 32;
